import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LoginPage } from './components/LoginPage';
import { Layout } from './components/Layout';
import { TemplateSetup } from './components/TemplateSetup';
import { TemplateDetail } from './components/TemplateDetail';
import { AgentCatalog } from './components/AgentCatalog';
import { MyAgents } from './components/MyAgents';
import { AgentDetail } from './components/AgentDetail';
import { DialogsPage } from './components/DialogsPage';
import { WorkspaceSetup } from './components/WorkspaceSetup';
import { WorkspaceForm } from './components/WorkspaceForm';
import { TemplateCreate } from './components/TemplateCreate';
import { ApiDocsPage } from './components/ApiDocsPage';
import { UsersPage } from './components/UsersPage';
import { KnowledgePage } from './components/KnowledgePage';
import { ChatPage } from './pages/ChatPage';
import { ComparePage } from './pages/ComparePage';

function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <div style={{ padding: 20, color: '#888' }}>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <div style={{ padding: 20, color: '#888' }}>Loading...</div>;

  return (
    <Routes>
      <Route path="login" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/templates" replace />} />
          <Route path="templates" element={<TemplateSetup />} />
          <Route path="templates/new" element={<TemplateCreate />} />
          <Route path="templates/:templateId" element={<TemplateDetail />} />
          <Route path="templates/:templateId/create-agent" element={<AgentCatalog />} />
          <Route path="agents" element={<MyAgents />} />
          <Route path="agents/:agentId" element={<AgentDetail />} />
          <Route path="knowledge" element={<KnowledgePage />} />
          <Route path="chat" element={<ChatPage />} />
          <Route path="compare" element={<ComparePage />} />
          <Route path="api-docs" element={<ApiDocsPage />} />
          <Route path="admin/workspaces" element={<WorkspaceSetup />} />
          <Route path="admin/workspaces/new" element={<WorkspaceForm />} />
          <Route path="admin/workspaces/:workspaceId" element={<WorkspaceForm />} />
          <Route path="admin/dialogs" element={<DialogsPage />} />
          <Route path="admin/sessions" element={<Navigate to="/admin/dialogs" replace />} />
          <Route path="admin/users" element={<UsersPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
